import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/trust_wallet.svg")